import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Project from './models/Project';

import ProjectOverview from './models/ProjectOverview';

export interface ProjectState {
    selectedProjectOverview?: ProjectOverview;
    selectedProject?: Project;
    saved: boolean;
    isSaving: boolean;
    showError: boolean;
}

const initialState: ProjectState = {
    selectedProjectOverview: undefined,
    selectedProject: undefined,
    saved: false,
    isSaving: false,
    showError: false,
}

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        setSelectedProjectOverview: (state, action: PayloadAction<ProjectOverview >) => {
            state.selectedProjectOverview = action.payload;
        },
        setSelectedProject: (state, action: PayloadAction<Project>) => {
            state.selectedProject = action.payload;
        },
        clearSelectedProjectOverview: (state) => {
            state.selectedProjectOverview = undefined;
        },
        clearSelectedProject: (state) => {
            state.selectedProject = undefined;
        },
        setSaved: (state, action: PayloadAction<boolean>) => {
            state.saved = action.payload;
        },
        setIsSaving: (state, action: PayloadAction<boolean>) => {
            state.isSaving = action.payload;
        },
        setShowError: (state, action: PayloadAction<boolean>) => {
            state.showError = action.payload;
        }
    }
})

export const { setSelectedProjectOverview, setShowError, setSelectedProject, clearSelectedProjectOverview, clearSelectedProject } = projectSlice.actions;
export default projectSlice.reducer;